import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

const TextContainer = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
  margin-bottom: 10px;
  gap: 5px;
`;

const TruncatedText = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  white-space: normal;
`;

const ExpandedText = styled.div`
  white-space: break-spaces;
`;

const EllipsisSymbol = styled.span`
  color: var(--dark-blue);
  cursor: pointer;
  margin-left: 4px;
`;

interface Props {
  text: string;
}

const ShopNotesMultiParagraphText = ({ text }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const [firstParagraph, setFirstParagraph] = useState<string>();
  const [remainingParagraphs, setRemainingParagraphs] = useState<string>();
  const handleToggle = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    const firstTextParagraph = text?.trim().split('\n')[0];
    const remainingTextParagraphs = text?.split('\n').slice(1).join('\n');

    setFirstParagraph(firstTextParagraph);
    setRemainingParagraphs(remainingTextParagraphs);
  }, [text]);

  return (
    <TextContainer>
      {!expanded && (
        <>
          <TruncatedText>
            <span>{firstParagraph}</span>
            {(remainingParagraphs?.trim() || '').length > 0 && (
              <EllipsisSymbol onClick={handleToggle}>Show More</EllipsisSymbol>
            )}
          </TruncatedText>
        </>
      )}

      {expanded && (
        <ExpandedText>
          <span>{firstParagraph}</span>
          <span>{remainingParagraphs}</span>
          <EllipsisSymbol onClick={handleToggle}>Show Less</EllipsisSymbol>
        </ExpandedText>
      )}
    </TextContainer>
  );
};

export default ShopNotesMultiParagraphText;
